import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X, Send } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getWaPublic } from "@/lib/whatsapp";
import WaIcon from "@/components/whatsapp/WaIcon";

export default function WhatsAppWidget() {
    const { pathname } = useLocation();
    const { user } = useAuth();
    const [cfg, setCfg] = useState(null);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", phone: "", text: "" });
    const [sending, setSending] = useState(false);

    useEffect(() => { getWaPublic().then(setCfg); }, []);
    useEffect(() => {
        if (user) setForm((f) => ({ ...f, name: f.name || user.service_name || user.name || "", phone: f.phone || user.phone || "" }));
    }, [user]);

    if (!cfg?.widget_enabled || pathname.startsWith("/admin")) return null;

    const send = async (e) => {
        e.preventDefault();
        if (!form.text.trim()) return;
        setSending(true);
        const win = window.open("", "_blank");
        try {
            const { data } = await api.post("/whatsapp/web-message", form);
            if (data.wa_link && win) win.location.href = data.wa_link;
            else win?.close();
            setForm((f) => ({ ...f, text: "" }));
            setOpen(false);
        } catch {
            win?.close();
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="fixed bottom-5 right-5 z-40" data-testid="wa-widget">
            {open && (
                <form onSubmit={send} className="mb-3 w-[320px] max-w-[calc(100vw-2.5rem)] bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden wa-pop" data-testid="wa-widget-panel">
                    <div className="bg-[#075E54] text-white px-4 py-3 flex items-center justify-between">
                        <div className="flex items-center gap-2 font-display font-bold"><WaIcon className="w-5 h-5" /> Shkruani në WhatsApp</div>
                        <button type="button" onClick={() => setOpen(false)} data-testid="wa-widget-close"><X className="w-4 h-4" /></button>
                    </div>
                    <div className="p-4 space-y-2 bg-[#ECE5DD]">
                        <div className="bg-white rounded-lg rounded-tl-none px-3 py-2 text-sm text-slate-700 shadow-sm w-fit max-w-[85%]">Përshëndetje! Si mund t'ju ndihmojmë?</div>
                        <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Emri / Servisi" className="w-full rounded-lg px-3 py-2 text-sm border border-slate-200 outline-none" data-testid="wa-widget-name" />
                        <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Nr. juaj WhatsApp (+355…)" className="w-full rounded-lg px-3 py-2 text-sm border border-slate-200 outline-none font-mono" data-testid="wa-widget-phone" />
                        <textarea required rows="3" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} placeholder="Mesazhi juaj…" className="w-full rounded-lg px-3 py-2 text-sm border border-slate-200 outline-none resize-none" data-testid="wa-widget-text" />
                        <button disabled={sending} className="w-full flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white font-bold py-2.5 transition-colors" data-testid="wa-widget-send">
                            <Send className="w-4 h-4" /> Dërgo në WhatsApp
                        </button>
                    </div>
                </form>
            )}
            <button onClick={() => setOpen((o) => !o)} className="ml-auto w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl hover:scale-105 transition-transform wa-ring" aria-label="WhatsApp" data-testid="wa-widget-button">
                {open ? <X className="w-6 h-6" /> : <WaIcon className="w-7 h-7" />}
            </button>
        </div>
    );
}
